import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@shieldpay/bumblebee/button';
import { Heading } from '@shieldpay/bumblebee/heading';
import { Row } from '@shieldpay/bumblebee/layout';
import ModalMarkdown from '@shieldpay/bumblebee/markdown/modal.md';
import { Modal } from '@shieldpay/bumblebee/modal';
import { Text } from '@shieldpay/bumblebee/text';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.modal.title',
});

export const ModalComponentPage = () => {
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);

  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.modal.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview>
        <Row spacing="basePos3">
          <Button
            onClick={() => {
              setOpen1(!open1);
            }}
          >
            Open dismissable modal
          </Button>

          <Modal
            closeDialogText="close"
            open={open1}
            onClose={() => setOpen1(false)}
            dismissable
          >
            <Modal.Title>Modal with two buttons</Modal.Title>
            <Text paragraph>
              Modal dialog body text describing what the user needs to do next
              and why they need to do it.
            </Text>
            <Modal.Actions>
              <Modal.CloseButton>Close Button</Modal.CloseButton>
              <Button onClick={() => setOpen1(false)} variant="outline">
                Secondary
              </Button>
            </Modal.Actions>
          </Modal>

          <Button
            onClick={() => {
              setOpen2(!open2);
            }}
          >
            Open undismissable modal
          </Button>

          <Modal
            closeDialogText="close"
            open={open2}
            onClose={() => setOpen2(false)}
            dismissable={false}
          >
            <Modal.Title>Modal with one button</Modal.Title>
            <Text paragraph>
              Modal dialog body text describing what the user needs to do next
              and why they need to do it.
            </Text>
            <Modal.Actions>
              <Modal.CloseButton>Close Button</Modal.CloseButton>
            </Modal.Actions>
          </Modal>
        </Row>
      </ComponentPreview>

      <MdxFormatter md={ModalMarkdown} />
    </>
  );
};

export default ModalComponentPage;
